import React from "react";
import { Fieldset } from 'primereact/fieldset';
import moment from "moment";
 
function ContactDetailView({ user, contacts }) {

  const view = (
    <React.Fragment>
      <Fieldset legend="Basic" toggleable className="mb-1 Contact-Detail-View">
      <p>
        <b className="col-5">Role :</b>
        <span className="col-7" style={{ textTransform: 'capitalize' }}>{user?.Designation?.title || ""}</span>
      </p>

      <p>
        <b className="col-5">Date Of Joining : </b>
        <span className="col-7">{moment(user?.doj).format("DD-MM-YYYY") || ''}</span>
      </p>

      <p className="capitalize">
        <b><span className="col-5">Reports to :</span></b>
        <span className="col-7"><span style={{ textTransform: 'capitalize' }}>{user?.superior?.firstName || ""}{" "}{user?.superior?.lastName || ""}</span>{" "}<span style={{ fontWeight: "bold" }}>({user?.superior?.Designation?.title || ""})</span></span>
      </p>

      <p className="capitalize">
        <b><span className="col-5">Location :</span>
          <span className="col-7"><span style={{ textTransform: 'capitalize' }}>{user?.LegalEntity?.code}</span>{" "}{user?.location_type === "" || user?.location_type === null ? '' : <span>({user?.location_type})</span>}</span></b>
      </p>

      <p className="capitalize">
        <b><span className="col-5">Department :</span></b>
        <span className="col-7" style={{ textTransform: 'capitalize' }}>{user?.Department?.title}</span>
      </p>
      </Fieldset>

      {contacts.length > 0 ? (
        <Fieldset legend="Alternate" toggleable className="mb-1 Contact-Detail-View">
          <p className="links">
            <span>
              {contacts.length > 0 ? (
                <span>
                  <i className="pi pi-envelope" />
                  {contacts?.[0]?.alternateEmail}
                </span>
              ) : (
                ""
              )}
            </span>

            <p>
              <span>
                {contacts.length > 0 ? (
                  <span>
                    <i className="pi pi-phone" />
                    {contacts?.[0]?.alternatePhone}
                  </span>
                ) : (
                  ""
                )}
              </span>
            </p>
          </p>
        </Fieldset>
      ) : (
        ""
      )}

      {contacts.length > 0 ? (
        <Fieldset legend="Present Address" toggleable className="mb-1 Contact-Detail-View">
          <p className="links">
            <span>
              <i className="pi pi-home" />
              {contacts?.[0]?.currentAddress || ""}{" "}
              {contacts?.[0]?.currentAddress1 || ""}{" "}
              {contacts?.[0]?.currentCity || ""}{" "}
              {contacts?.[0]?.currentState || ""}{" "}
              {contacts?.[0]?.currentCountry || ""}{" "}
              {contacts?.[0]?.currentPincode || ""}{" "}
            </span>
          </p>
        </Fieldset>
      ) : (
        ""
      )}

      {contacts.length > 0 ? (
        <Fieldset legend="Permanent Address" toggleable className="mb-1 Contact-Detail-View">
          <p className="links">
            <span>
              <i className="pi pi-home" />
              {contacts?.[0]?.permanentAddress || ""}{" "}
              {contacts?.[0]?.permanentAddress1 || ""}{" "}
              {contacts?.[0]?.permanentCity || ""}{" "}
              {contacts?.[0]?.permanentState || ""}{" "}
              {contacts?.[0]?.permanentCountry || ""}{" "}
              {contacts?.[0]?.permanentPincode || ""}{" "}
            </span>
          </p>
        </Fieldset>
      ) : (
        ""
      )}
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {view}
    </React.Fragment>
  );
}

export default ContactDetailView;